import { doPost, doGet } from './ServerTools';

export function login(data) {
  return doPost('/api/account/login', data);
}

export function check_login() {
  return doGet('/api/account/check_login');
}
